import { API_METHODS } from './api.enums';
import { apiAction } from './utils.actions';

export type NotificationSettingsParams = {
    userid: number;
    notificationId?: number;
    jwtToken?: string;
}

export type NotificationResponse = {
    notificationid: number;
    description: string;
}

const addJwt = (jwt? : string) => (jwt ? `?token=${encodeURIComponent(jwt)}` : '');

export const getUserNotifications = (params: NotificationSettingsParams) => apiAction<NotificationResponse[]>({
    url: `/user/${params.userid}/notifications${addJwt(params.jwtToken)}`,
    method: API_METHODS.GET,
});

export const addNotification = (params: NotificationSettingsParams) => apiAction<any>({
    url: `/user/${params.userid}/notifications/${params.notificationId}${addJwt(params.jwtToken)}`,
    method: API_METHODS.POST,
});

export const removeNotification = (params: NotificationSettingsParams) => apiAction<any>({
    url: `/user/${params.userid}/notifications/${params.notificationId}${addJwt(params.jwtToken)}`,
    method: API_METHODS.DELETE,
});

export type RemoveSearchKeyParams = { searchKeyId: number, userid: number; };
export const removeSearchKey = (params: RemoveSearchKeyParams) => apiAction<any>({
    url: `/users/${params.userid}/search-keys/${params.searchKeyId}`,
    method: API_METHODS.DELETE,
});
